@if (filtersEnabled) {
  <div class="border-b-ui-gray-light border-b flex items-center justify-between">
    <mat-button-toggle-group
      class="desktop-toggle-group"
      (change)="onTabChange($event.value)"
      [value]="criteriaStore.tab()"
      aria-label="Incident Status"
      name="incident-status"
    >
      <mat-button-toggle
        class="test-incident-status-open"
        [value]="incidentTabStatusFilterEnum.OPEN"
      >
        <span class="item-status-title">Open</span>
      </mat-button-toggle>
      <mat-button-toggle
        class="test-incident-status-history"
        [value]="incidentTabStatusFilterEnum.HISTORY"
      >
        <span class="item-status-title">History</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

@if (criteriaStore.tab() === incidentTabStatusFilterEnum.OPEN && filtersEnabled && (criteriaStore.availableFilters() || !dropdownFilters)) {
  <div class="test-open-incidents-filters flex items-start justify-between mt-3">
    <div class="flex flex-wrap">
      <div class="flex justify-center mr-2">
        <app-search-input
          (searchDataEvent)="onSearchChange($event)"
          placeholder="Enter Ticket №"
        />
      </div>
      @if (dropdownFilters) {

        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="onDeviceTypeChange($event)"
          [options]="criteriaStore.deviceTypeOptions()"
          [value]="criteriaStore.deviceTypeValue()"
          label="Device Type"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (showLocationFilters()) {
        <mat-form-field
          class="stroked-select-single mr-2 mb-3"
          appearance="outline"
        >
          <mat-select-trigger>Building</mat-select-trigger>
          <mat-select
            (ngModelChange)="onBuildingChange($event)"
            [ngModel]="criteriaStore.selectedBuilding()"
            panelClass="single-select-overlay test-building-select-filter"
          >
            @for (building of criteriaStore.buildingOptions() | sort : 'asc' : 'title' : 'all'; track building.value) {
              <mat-option [value]="building.value">
                {{ building.title }}
              </mat-option>
            }
          </mat-select>
          <mat-icon
            class="arrow-down"
            matSuffix
          >keyboard_arrow_down
          </mat-icon>
        </mat-form-field>

        @if (criteriaStore.selectedBuilding()) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Floor</mat-select-trigger>
            <mat-select
              (ngModelChange)="onFloorChange($event)"
              [ngModel]="criteriaStore.selectedFloor()"
              panelClass="single-select-overlay test-floor-select-filter"
            >
              @for (floor of criteriaStore.floorOptions() | sort : 'asc' : 'title' : 'all'; track floor.value) {
                <mat-option [value]="floor.value">
                  {{ floor.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (criteriaStore.selectedFloor()) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Room</mat-select-trigger>
            <mat-select
              (ngModelChange)="onRoomChange($event)"
              [ngModel]="criteriaStore.selectedRoom()"
              panelClass="single-select-overlay test-room-select-filter"
            >
              @for (room of criteriaStore.roomOptions() | sort : 'asc' : 'title' : 'all'; track room.value) {
                <mat-option [value]="room.value">
                  {{ room.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }
        }

        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="onSeverityChange($event)"
          [options]="criteriaStore.severityOptions()"
          [value]="criteriaStore.severityFilter()"
          label="Severity"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (criteriaStore.hasSelectedFilters()) {
          <button
            class="text-sm text-ui-dark font-normal underline h-9 ml-3 mb-3 test-clear-all-open-incidents-filters"
            (click)="onClearOpenFilters()"
          >
            Clear All
          </button>
        }
      }
    </div>

    @if (showColumnSelect) {
      <ng-container *ngTemplateOutlet="columnSelect" />
    }
  </div>
}
<!-- Reuses the Open-tab options: available filters are scoped to open incidents server-side, so resolved-only buildings/device types are missing (known limitation). -->
@if (criteriaStore.tab() === incidentTabStatusFilterEnum.HISTORY) {
  <div class="test-resolved-incidents-filters flex items-start justify-between mt-3">
    <div class="flex flex-wrap">
    @if (criteriaStore.tab() === incidentTabStatusFilterEnum.HISTORY) {
      <avs-date-picker
        class="block w-72 mr-2 mb-3"
        (changed)="onResolvedDateRangeChange($event)"
        [disabled]="resolvedIncidentsLoading"
        [minDate]="minDate"
      />
    }
    @if (resolvedIncidentsLoading) {
      <mat-spinner
        class="mr-2"
        color="primary"
        diameter="36"
        matSuffix
      />
    }

      @if (dropdownFilters && criteriaStore.availableFilters()) {
        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="onResolvedDeviceTypeChange($event)"
          [options]="criteriaStore.deviceTypeOptions()"
          [value]="criteriaStore.resolvedIncidentsDeviceTypeValue()"
          label="Device Type"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (showLocationFilters()) {
        <mat-form-field
          class="stroked-select-single mr-2 mb-3"
          appearance="outline"
        >
          <mat-select-trigger>Building</mat-select-trigger>
          <mat-select
            (ngModelChange)="onResolvedBuildingChange($event)"
            [ngModel]="criteriaStore.resolvedIncidentsSelectedBuilding()"
            panelClass="single-select-overlay test-building-select-filter"
          >
            @for (building of criteriaStore.buildingOptions() | sort : 'asc' : 'title' : 'all'; track building.value) {
              <mat-option [value]="building.value">
                {{ building.title }}
              </mat-option>
            }
          </mat-select>
          <mat-icon
            class="arrow-down"
            matSuffix
          >keyboard_arrow_down
          </mat-icon>
        </mat-form-field>

        @if (criteriaStore.resolvedIncidentsSelectedBuilding()) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Floor</mat-select-trigger>
            <mat-select
              (ngModelChange)="onResolvedFloorChange($event)"
              [ngModel]="criteriaStore.resolvedIncidentsSelectedFloor()"
              panelClass="single-select-overlay test-floor-select-filter"
            >
              @for (floor of criteriaStore.floorOptions() | sort : 'asc' : 'title' : 'all'; track floor.value) {
                <mat-option [value]="floor.value">
                  {{ floor.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (criteriaStore.resolvedIncidentsSelectedFloor()) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Room</mat-select-trigger>
            <mat-select
              (ngModelChange)="onResolvedRoomChange($event)"
              [ngModel]="criteriaStore.resolvedIncidentsSelectedRoom()"
              panelClass="single-select-overlay test-room-select-filter"
            >
              @for (room of criteriaStore.roomOptions() | sort : 'asc' : 'title' : 'all'; track room.value) {
                <mat-option [value]="room.value">
                  {{ room.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }
        }

        @if (criteriaStore.resolvedIncidentsSelectedFilters()) {
          <button
            class="text-sm text-ui-dark font-normal underline h-9 ml-3 mb-3 test-clear-all-resolved-incidents-filters"
            (click)="onClearResolvedFilters()"
            mat-button
          >
            Clear All
          </button>
        }
      }
    </div>
    @if (showColumnSelect) {
      <ng-container *ngTemplateOutlet="columnSelect"></ng-container>
    }
  </div>
}


<ng-template #columnSelect>
  <div class="flex flex-wrap">
    <mat-form-field
      class="column-select mb-3"
      appearance="outline"
      matTooltip="Column Select"
    >
      <mat-select
        (selectionChange)="columnListUpdated($event)"
        [formControl]="columnSelectControl"
        #columnSelectRef
        multiple
        panelClass="multi-select-overlay column-select-overlay"
      >
        <mat-select-trigger>
          <i class="icon-ic_column text-3xl"></i>
        </mat-select-trigger>
        <div class="options-action-wrapper">
          <button
            class="options-action-button"
            (click)="selectAllColumns()"
          >
            Select All
          </button>
        </div>
        @for (option of criteriaStore.columnOptions(); track option.value) {
          <mat-option [value]="option.value">
            {{ option.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
